export const encodeMetadataLanguagePart = (value: string): string =>
  String(value || '').trim().replace(/ /g, '0');

export const metadataTranslationFieldKey = (
  field: string,
  sourceLang: string,
  targetLang: string,
): string => `${field}_${encodeMetadataLanguagePart(sourceLang)}_${encodeMetadataLanguagePart(targetLang)}`;
